__webpack_require__.p = "https://client.orientcapital.kz/packs/";